import {createSelector} from 'reselect';
import {pathOr} from 'ramda';

import {ApplicationStoreType, SelectorType} from 'constants/flow/flowTypes';

import {getCurrentPage} from 'selectors/app/app';

/**
 * Returns cmsBlock
 */
export const getCmsBlock: SelectorType<{}> = pathOr('', ['cmsBlock']);

/**
 * Returns cart key from store
 * @param {ApplicationStoreType} store - Current store
 * @returns {string} - Stored cartKey
 */
export const getBannerHtml = createSelector(
    getCurrentPage,
    getCmsBlock,
    (currentPage, cmsBlock) => {
        return pathOr('', ['collection', `${currentPage.page}_banner`, 'content'], cmsBlock);
    },
);

/**
 * Returns coupon code
 * @param {ApplicationStoreType} store - Current store
 * @param {string} bannerName - Banner's name
 * @returns {string} Coupon code
 */
export const getCouponCode = (store: ApplicationStoreType, bannerName: string) =>
    pathOr('', ['cmsBlock', 'collection', bannerName, 'coupon_code'], store);

/**
 * Is CMS data in pending status?
 * @param {ApplicationStoreType} store - Current store
 * @returns {boolean} - flag of pending status
 */
export const isCmsBlockPending: SelectorType<boolean> = (store: ApplicationStoreType) =>
    pathOr('', ['cmsBlock', 'status'], store) === 'pending';
